import React, { useState, useEffect } from 'react';
import { Users, Copy, Loader2, Gift } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminReferrals = () => {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReferrals();
  }, []);

  const fetchReferrals = async () => {
    const token = localStorage.getItem('adminToken');
    try {
      const response = await axios.get(`${API}/admin/referrals`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setReferrals(response.data);
    } catch (err) {
      console.error('Error fetching referrals:', err);
      toast.error('Error al cargar los referidos');
    } finally {
      setLoading(false);
    }
  };

  const copyCode = (code) => {
    navigator.clipboard.writeText(code);
    toast.success('Código copiado');
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-[#C2410C]" />
      </div>
    );
  }

  return (
    <div className="p-6 lg:p-8" data-testid="admin-referrals">
      <div className="mb-8">
        <h1 className="text-3xl font-display font-bold text-[#1C1917]">Programa de Referidos</h1>
        <p className="text-[#57534E]">Member Get Member - Clientes que recomiendan a amigos</p>
      </div>

      {/* How it works */}
      <Card className="mb-8 bg-gradient-to-br from-[#C2410C]/5 to-[#F59E0B]/5 border-[#C2410C]/20">
        <CardContent className="pt-6">
          <div className="flex items-start gap-4">
            <Gift className="h-8 w-8 text-[#C2410C] flex-shrink-0" />
            <div>
              <h3 className="font-semibold text-lg mb-2">¿Cómo funciona?</h3>
              <ol className="space-y-2 text-sm text-[#57534E]">
                <li>1. Un cliente completa un tour y deja una reseña</li>
                <li>2. Automáticamente recibe un código de referido personal</li>
                <li>3. Comparte el código con amigos y familia</li>
                <li>4. Sus referidos obtienen un <strong>10% de descuento</strong> en su reserva</li>
              </ol>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Referrals List */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Users className="h-5 w-5 text-[#C2410C]" />
            Códigos de Referido Activos
          </CardTitle>
        </CardHeader>
        <CardContent>
          {referrals.length === 0 ? (
            <p className="text-center text-[#57534E] py-8">
              Aún no hay códigos de referido. Se generan automáticamente cuando un cliente deja una reseña.
            </p>
          ) : (
            <div className="space-y-4">
              {referrals.map((referral) => (
                <div
                  key={referral.id}
                  className="flex items-center justify-between p-4 bg-[#FDFBF7] rounded-lg"
                >
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-[#C2410C] flex items-center justify-center text-white font-bold">
                      {referral.referrer_name.charAt(0)}
                    </div>
                    <div>
                      <p className="font-medium">{referral.referrer_name}</p>
                      <p className="text-sm text-[#57534E]">{referral.referrer_email}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="text-right">
                      <p className="font-mono font-bold text-[#C2410C]">{referral.referral_code}</p>
                      <p className="text-sm text-[#57534E]">
                        {referral.uses} usos • {referral.discount_percentage}% dto.
                      </p>
                    </div>
                    <Button
                      variant="outline"
                      size="icon"
                      onClick={() => copyCode(referral.referral_code)}
                    >
                      <Copy className="h-4 w-4" />
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminReferrals;
